// src/pages/pages/GCP/GCPCloudAlerts.js

import React, { useEffect, useState } from "react";
import { myLocalStorage } from "../../../components/StorageHelper";
import axios from "axios";
import { NGROK } from "../../../APIs";
import useUserStore from "../../../services/userStore";
import CloudAnomalyAlertsTable from "../../../components/v2components/CloudSightAlerts/components/CloudAnomalyAlertsTable";

const GCPCloudAlerts = () => {
    const [selectedTenantName, setSelectedTenantName] = useState(null);
    const [tenantList, setTenantList] = useState([]);
    const [projectId, setProjectId] = useState(null);
    const [projectIdList, setProjectIdList] = useState([]);
    const userData = useUserStore((state) => state.user);

    const latestProjectId = myLocalStorage.getItem("gcpSelectedProjectId");
    const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;

    const handleProject = (value) => {
        const project = projectIdList.find((p) => p === value);
        if (project !== undefined) {
            setProjectId(project);
            myLocalStorage.setItem("gcpSelectedProjectId", project);
        }
    };

    const handleTenantChange = (value) => {
        const tenant = tenantList.find((t) => t.tenantName === value);
        if (tenant !== undefined) {
            setSelectedTenantName(tenant.tenantName);
            myLocalStorage.setItem("latestTenant", tenant);
        }
    };

    const fetchProjectIdList = async () => {
        if (!latestTenant) {
            setProjectIdList([]);
            return;
        }

        const response = await axios.get(`${NGROK}/api/gcp/auth/fetchAllProjectIds`, {
            params: {
                tenantName: latestTenant,
            },
        });
        setProjectIdList(response.data || []);
    };

    useEffect(() => {
        fetchProjectIdList();
        const interval = setInterval(() => {
            fetchProjectIdList();
        }, 10000);
        return () => clearInterval(interval);
    }, [latestTenant, latestProjectId]);

    useEffect(() => {
        if (tenantList.length === 1) {
            setSelectedTenantName(tenantList[0].tenantName);
            return;
        }

        if (tenantList.length > 1) {
            const storedTenantName = myLocalStorage.getItem("latestTenant")?.tenantName;
            const tenant =
                tenantList.find((t) => t.tenantName === storedTenantName) ||
                tenantList[0];
            setSelectedTenantName(tenant.tenantName);
        }
    }, [tenantList]);

    useEffect(() => {
        if (projectIdList.length === 1) {
            myLocalStorage.setItem("gcpSelectedProjectId", projectIdList[0]);
            setProjectId(projectIdList[0]);
            return;
        }

        if (projectIdList.length > 1) {
            const storedProjectId = myLocalStorage.getItem("gcpSelectedProjectId");
            const project = projectIdList.find((p) => p === storedProjectId);

            if (project) {
                setProjectId(project);
            } else {
                myLocalStorage.setItem("gcpSelectedProjectId", projectIdList[0]);
                setProjectId(projectIdList[0]);
            }
        }
    }, [projectIdList]);

    useEffect(() => {
        const fetchTenants = async () => {
            const response = await axios.get(`${NGROK}/api/get-all-domains`);
            setTenantList(response.data || []);
        };

        fetchTenants();
    }, [userData]);

    return (
        <CloudAnomalyAlertsTable
            cloud="GCP"
            cloudId={projectId}
            tenantName={selectedTenantName}
            tenantList={tenantList}
            cloudIdList={projectIdList}
            onTenantChange={handleTenantChange}
            onCloudIdChange={handleProject}
        />
    );
};

export default GCPCloudAlerts;